module.exports = __webpack_public_path__ + "img/loads--isSpanBySpan.7fca5058.png";